module.exports = __webpack_public_path__ + "img/faceflip.e16bab96.png";